const PHONE_VERIFICATION_STEPS = {
    ADD_PHONE_NUMBER: 'addPhoneNumber',
    GET_VERIFICATION_CODE: 'getVerificationCode',
    VERIFICATION_CODE_SENT: 'verificationCodeSent',
    VERIFICATION_SUCCESS: 'verificationSuccess',
};


export {
    PHONE_VERIFICATION_STEPS,
};
